var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98209 5.83778L4.80678 0.154333C4.6552 -0.0514445 4.34496 -0.0514445 4.19457 0.154333L0.0180729 5.83778C0.00779491 5.85176 0.00163786 5.86827 0.0002841 5.88549C-0.00106966 5.90272 0.0024328 5.91997 0.0104033 5.93535C0.0183738 5.95072 0.0305009 5.96362 0.0454405 5.97261C0.0603801 5.9816 0.0775484 5.98632 0.0950427 5.98627H0.983155C1.04355 5.98627 1.10039 5.95704 1.13591 5.9091L4.50008 1.33054L7.86425 5.9091C7.89978 5.95704 7.95662 5.98627 8.01701 5.98627H8.90512C8.98209 5.98627 9.02709 5.89975 8.98209 5.83778Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.3de0e50fb84d9ce0b99080b66f0c8c11.svg";
export { ForwardRef as ReactComponent };